import React, { ComponentProps, FC } from 'react'

export type KeyCheckboxProps = ComponentProps<'input'>

const base = 'rounded border-gray-200 text-white'
const checked = 'checked:bg-sky-400 checked:border-gray-200'
const checkedHover = 'checked:hover:bg-sky-300 checked:hover:border-gray-200'
const checkedFocus = 'checked:focus:border-gray-200'
const hover = 'hover:bg-sky-300 hover:border-gray-200'
const focus =
  'focus:outline-0 focus:ring-0 focus:ring-offset-0 focus:accent-transparent focus:checked:text-sky-400 focus:text-white'
const disabled = 'disabled:bg-gray-400 disabled:border-gray-200'
const disabledHover = 'disabled:hover:bg-gray-400 disabled:hover:border-gray-200'

const classes = [
  base,
  checked,
  checkedHover,
  checkedFocus,
  hover,
  focus,
  disabled,
  disabledHover,
].join(' ')

// KEY Design Language Checkbox | See examples in ops/components

/**
 * @deprecated key-* components are no longer supported.
 */
export const KeyCheckbox: FC<KeyCheckboxProps> = (props) => {
  const { className, ...inputProps } = props

  return (
    <input
      type='checkbox'
      className={`${classes} ${className}`}
      {...inputProps}
    />
  )
}
